import script from "./AllTasksView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllTasksView.vue?vue&type=script&setup=true&lang=ts"

import "./AllTasksView.vue?vue&type=style&index=0&id=51f777fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f777fe"]])

export default __exports__